"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.renalReplacementTherapyTypeMessages = exports.RenalReplacementTherapyType = void 0;
const schema_1 = require("../../../../schema");
var RenalReplacementTherapyType;
(function (RenalReplacementTherapyType) {
    RenalReplacementTherapyType["NO_RTT_RENAL_REPLACEMENT_THERAPY"] = "NoRTT_renal_replacement_therapy";
    RenalReplacementTherapyType["KIDNEY_TRANSPLANT"] = "kidney_transplant";
    RenalReplacementTherapyType["HD_RENAL_REPLACEMENT_THERAPY"] = "HD_renal_replacement_therapy";
    RenalReplacementTherapyType["CAPD_RENAL_REPLACEMENT_THERAPY"] = "CAPD_renal_replacement_therapy";
    RenalReplacementTherapyType["APD_RENAL_REPLACEMENT_THERAPY"] = "APD_renal_replacement_therapy";
    RenalReplacementTherapyType["HHD_RENAL_REPLACEMENT_THERAPY"] = "HHD_renal_replacement_therapy";
    RenalReplacementTherapyType["OTHER_RENAL_REPLACEMENT_THERAPY"] = "other_renal_replacement_therapy";
})(RenalReplacementTherapyType || (exports.RenalReplacementTherapyType = RenalReplacementTherapyType = {}));
exports.renalReplacementTherapyTypeMessages = {
    [RenalReplacementTherapyType.NO_RTT_RENAL_REPLACEMENT_THERAPY]: {
        id: "ktx.basicRegistrationData.waitingListData.renalReplacementTherapy.renalReplacementTherapyType.NO_RTT_RENAL_REPLACEMENT_THERAPY",
        defaultMessage: "ND"
    },
    [RenalReplacementTherapyType.KIDNEY_TRANSPLANT]: {
        id: "ktx.basicRegistrationData.waitingListData.renalReplacementTherapy.renalReplacementTherapyType.KIDNEY_TRANSPLANT",
        defaultMessage: "Vesetranszplantáció"
    },
    [RenalReplacementTherapyType.HD_RENAL_REPLACEMENT_THERAPY]: {
        id: "ktx.basicRegistrationData.waitingListData.renalReplacementTherapy.renalReplacementTherapyType.HD_RENAL_REPLACEMENT_THERAPY",
        defaultMessage: "HD"
    },
    [RenalReplacementTherapyType.CAPD_RENAL_REPLACEMENT_THERAPY]: {
        id: "ktx.basicRegistrationData.waitingListData.renalReplacementTherapy.renalReplacementTherapyType.CAPD_RENAL_REPLACEMENT_THERAPY",
        defaultMessage: "CAPD"
    },
    [RenalReplacementTherapyType.APD_RENAL_REPLACEMENT_THERAPY]: {
        id: "ktx.basicRegistrationData.waitingListData.renalReplacementTherapy.renalReplacementTherapyType.APD_RENAL_REPLACEMENT_THERAPY",
        defaultMessage: "APD"
    },
    [RenalReplacementTherapyType.HHD_RENAL_REPLACEMENT_THERAPY]: {
        id: "ktx.basicRegistrationData.waitingListData.renalReplacementTherapy.renalReplacementTherapyType.HHD_RENAL_REPLACEMENT_THERAPY",
        defaultMessage: "HHD"
    },
    [RenalReplacementTherapyType.OTHER_RENAL_REPLACEMENT_THERAPY]: {
        id: "ktx.basicRegistrationData.waitingListData.renalReplacementTherapy.renalReplacementTherapyType.OTHER_RENAL_REPLACEMENT_THERAPY",
        defaultMessage: "Egyéb vesepótló kezelés"
    }
};
const renalReplacementTherapyType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(RenalReplacementTherapyType.NO_RTT_RENAL_REPLACEMENT_THERAPY)
        .interpretation({
        vocab: "ktx",
        code: "NoRTT_renal_replacement_therapy"
    })
        .tag({ vocab: "ktx", code: "renal_replacement_therapy" }),
    schema_1.Schema.singleChoiceItem(RenalReplacementTherapyType.KIDNEY_TRANSPLANT)
        .interpretation({ vocab: "ktx", code: "kidney_transplant" })
        .tag({ vocab: "ktx", code: "renal_replacement_therapy" }),
    schema_1.Schema.singleChoiceItem(RenalReplacementTherapyType.HD_RENAL_REPLACEMENT_THERAPY)
        .interpretation({ vocab: "ktx", code: "HD_renal_replacement_therapy" })
        .tag({ vocab: "ktx", code: "renal_replacement_therapy" }),
    schema_1.Schema.singleChoiceItem(RenalReplacementTherapyType.CAPD_RENAL_REPLACEMENT_THERAPY)
        .interpretation({
        vocab: "ktx",
        code: "CAPD_renal_replacement_therapy"
    })
        .tag({ vocab: "ktx", code: "renal_replacement_therapy" }),
    schema_1.Schema.singleChoiceItem(RenalReplacementTherapyType.APD_RENAL_REPLACEMENT_THERAPY)
        .interpretation({ vocab: "ktx", code: "APD_renal_replacement_therapy" })
        .tag({ vocab: "ktx", code: "renal_replacement_therapy" }),
    schema_1.Schema.singleChoiceItem(RenalReplacementTherapyType.HHD_RENAL_REPLACEMENT_THERAPY)
        .interpretation({ vocab: "ktx", code: "HHD_renal_replacement_therapy" })
        .tag({ vocab: "ktx", code: "renal_replacement_therapy" }),
    schema_1.Schema.singleChoiceItem(RenalReplacementTherapyType.OTHER_RENAL_REPLACEMENT_THERAPY)
]);
const renalReplacementTherapyTypeOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../renalReplacementTherapyType} === "other_renal_replacement_therapy"`), schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({
    vocab: "ktx",
    code: "other_renal_replacement_therapy"
})
    .tag({ vocab: "ktx", code: "renal_replacement_therapy" }));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    renalReplacementTherapyType,
    renalReplacementTherapyTypeOther
})
    .interpretation({
    vocab: "ktx",
    code: "renal_replacement_therapy_statement"
})
    .tag({ vocab: "fyrms", code: "action" });
